import { supabase } from './supabase';

/*
  Telling somebody something.

  Written 5 September 2026, fixing "Nobody is ever told anything", the third of
  the four faults an admin account hides.

  **The fault was not that the app forgot to send the notifications.** It sent
  ten kinds and the database accepted three. The other seven were refused
  because their names were not on the fixed list the database keeps, and **not
  one of the ten places that sent one ever looked at the answer**. So an
  administrator who approved a transfer, closed a location, denied an edit or
  rejected a count saw "done" and the rep was never told anything.

  The list is fixed now and all ten are accepted. This exists so that the next
  one is loud rather than silent: **a notification that does not arrive says so.**

  It takes the toast function the screen already has, rather than reaching for
  one itself, because the screens each own their own.
*/
export async function notify(toast, alert) {
  const { error } = await supabase.from('alerts').insert({ is_read: false, ...alert });
  if (error) {
    // Deliberately not swallowed and deliberately not silent. The person doing
    // the approving is the only one in a position to notice, and they are the
    // one who thinks the rep has been told.
    if (toast?.error) toast.error('Saved, but could not notify the rep: ' + error.message);
    return false;
  }
  return true;
}

/*
  Marking one read.

  **This did nothing, and it did nothing quietly.** There was no rule in the
  database letting anybody but an administrator change a notification, and an
  update that no rule allows does not fail in Postgres: it changes no rows and
  reports success. The screens then ticked the item off in the browser anyway,
  so it looked right until the page was reloaded.

  Both halves are fixed: the database has a rule now, and this returns whether
  anything actually changed rather than assuming it did.
*/
export async function markRead(ids) {
  const list = Array.isArray(ids) ? ids : [ids];
  if (list.length === 0) return true;
  const { data, error } = await supabase
    .from('alerts').update({ is_read: true }).in('id', list).select('id');
  return !error && (data || []).length > 0;
}
